module.exports = __webpack_public_path__ + "static/media/OverDue.7878c7db.svg";